import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {Subject} from 'rxjs';
import {Dispatch, Program} from '../../../../domain/cloud-topology';

@Component({
    selector: 'app-program-dispatches',
    templateUrl: './program-dispatches.component.html',
    standalone: false
})
export class ProgramDispatchesComponent implements OnInit, OnChanges, OnDestroy {

  @Input() program: Program;
  loading: boolean;
  dispatches: Dispatch[];
  activeTabId: string;
  private subject$: Subject<void>;

  constructor() { }

  ngOnInit(): void {
    this.subject$ = new Subject<void>();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['program']['currentValue'] !== undefined) {
      this.program = changes['program']['currentValue'];
    }
  }

  ngOnDestroy(): void {
    this.subject$.next();
    this.subject$.complete();
  }

}
